module.exports = __webpack_public_path__ + "media/src/images/companies-db3ab00c13076b11b54aeaa0c8b51186.jpg";